(() => {
  // app/scripts/product-recommendations.js
  if (!customElements.get("product-recommendations")) {
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        if (!this.hasAttribute("available"))
          return;
        this.initializeRecommendations();
      }
      disconnectedCallback() {
        if (!this.hasAttribute("available"))
          return;
        if (!this.isIntersecting)
          this.observer?.unobserve(this);
      }
      initializeRecommendations() {
        this.observer = new IntersectionObserver((entries, observer) => {
          if (!entries[0].isIntersecting)
            return;
          observer.unobserve(this);
          this.isIntersecting = true;
          this.loadRecommendations();
        }, { rootMargin: "400px 0px 400px 0px" });
        this.observer.observe(this);
      }
      loadRecommendations() {
        fetch(`${this.dataset.url}&product_id=${this.dataset.productId}&section_id=${this.dataset.id}`).then((response) => response.text()).then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations?.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this.setAttribute("loaded", "true");
          }
        }).catch((e) => {
          console.error(e);
        });
      }
    }
    customElements.define("product-recommendations", ProductRecommendations);
  }
})();
